import React from 'react'
import MaterialSymbol from '../material-symbol'

const StarBorder = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="star_border" {...props} />
))

StarBorder.displayName = 'StarBorder'

export default StarBorder
